<div class="form-container">
  <h2>{{pageTitle}}</h2>
  @if (projectview !== 'view') {
    <div class="project-form col-md-8 pl0">
      <alert></alert>
      <form [formGroup]="projectForm" (ngSubmit)="onSubmit()" novalidate>
        @if (projectview != 'assign') {
          <div class="form-row">
            <div class="col-md-6">
              <input type="text" class="form-control form-control-sm" formControlName="name"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; projectForm.controls.name.errors }"
                placeholder="Project name">
              @if (submitted && projectForm.controls.name.errors) {
                <div class="text-danger">
                  @if (projectForm.controls.name.errors.required) {
                    <div>Project name is required</div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (projectview != 'assign') {
          <div class="form-row">
            <div class="col-md-6" [ngClass]="projectview === 'edit' ? 'disabled-field' : ''">
              <select class="form-control form-control-sm" id="customerDropdown" formControlName="customer"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; projectForm.controls.customer.errors }"
                (change)="selectCustomer($event)">
                <option value="">Select customer*</option>
                @for (customer of customers; track customer) {
                  <option value="{{customer.id}}">{{customer.name}}</option>
                }
              </select>
              @if (submitted && projectForm.controls.customer.errors) {
                <div class="text-danger">
                  @if (projectForm.controls.customer.errors.required) {
                    <div>Customer is required</div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (projectview == 'assign') {
          <div class="form-row">
            <div class="col-md-6">
              <angular2-multiselect [data]="dropdownList" [settings]="dropdownSettings" formControlName="users">
              </angular2-multiselect>
              @if (submitted && projectForm.controls.users.errors) {
                <div class="text-danger">
                  @if (projectForm.controls.users.errors.required) {
                    <div>User is required</div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (projectview != 'assign') {
          <div class="form-row">
            <div class="col-md-8">
              <textarea class="form-control" rows="3" formControlName="description"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; projectForm.controls.description.errors }"
                placeholder="Description (optional)">
                Project description
              </textarea>
            </div>
          </div>
        }
        @if (projectview !== 'assign') {
          <div class="form-row">
            <div class="col-md-4">
              <select class="form-control form-control-sm" id="customerDropdown" formControlName="status"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; projectForm.controls.status.errors }">
                <option value="" selected hidden disabled>Status*</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              @if (submitted && projectForm.controls.status.errors) {
                <div class="text-danger">
                  @if (projectForm.controls.status.errors.required) {
                    <div>Status is required</div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (!showReturnButton) {
          <div class="form-row">
            <button type="submit" class="btn btn-sm btn-primary" [disabled]="loading">{{buttonTitle}}</button>
            <button (click)="navigateBack()" [style.margin-left.px]="16" type="button"
            class="btn btn-sm btn-outline-secondary" [disabled]="loading">Cancel</button>
          </div>
        }
        @if (showReturnButton) {
          <div class="form-row">
            <a class="btn btn-sm btn-primary" [routerLink]="['/dashboard/project/list']">Done</a>
          </div>
        }
      </form>
    </div>
  }

  <!-- VIEW MODE -->
  @if (projectview === 'view') {
    <div class="project-view col-md-8 pl0">
      <div class="row">
        <div class="col-md-3">Customer name</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{project.customer?.name}}</div>
      </div>
      <div class="row">
        <div class="col-md-3">Project name</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{project.name}}</div>
      </div>
      <div class="row">
        <div class="col-md-3">Status</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          @if (project.status=='active') {
            <span class="badge badge-success">{{project.status}}</span>
          }
          @if (project.status=='inactive') {
            <span class="badge badge-secondary">{{project.status}}</span>
          }
          @if (project.status=='DIP') {
            <span title="Delete in progress.">DIP</span>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">Creation Date</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{ project.createdAt | date:'shortDate' }}</div>
      </div>
      <div class="row">
        <div class="col-md-3">Description</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{ project.description }}</div>
      </div>
      <div class="row">
        <div class="col-md-3">Assigned Users</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          @for (user of assignedUsers; track user; let i = $index; let last = $last) {
            <span>
              {{user.email}}@if (!last) {
              <span>, </span>
            }
          </span>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">S3 Folder path</div>
      <div class="col-md-1">:</div>
      <div class="col-md-7">{{project.s3Path}}</div>
    </div>
    <div class="row">
      &nbsp;&nbsp;&nbsp;<a [routerLink]="['/dashboard/project/list']" class="btn btn-sm btn-primary">Back to Project
    List</a>
    &nbsp;&nbsp;&nbsp;<a [routerLink]="[]" (click)="viewProject(project)" [style.color]="'white'"
  class="btn btn-sm btn-primary">View Project</a>
  &nbsp;&nbsp;&nbsp;
  <a [routerLink]="[]" (click)="forceProjectCache(project.id)" [style.color]="'white'" class="btn btn-sm btn-secondary">
    Cache Analytics
    @if (isCaching === true) {
      <span class="spinner-border spinner-border-sm"></span>
    }
    @if (!isCaching) {
      <span>({{ !!project.cachedAnalytics ? 'cached' : 'not cached' }})</span>
    }
    @if (isCaching === 'done') {
      <span>(cached)</span>
    }
  </a>
</div>
</div>
}
</div>